<template>
  <div>
    <a-drawer
      :title="titleForm"
      :visible="visibleForm"
      v-bind="drawerConfig"
      :body-style="{ paddingBottom: '80px' }"
      @close="onClose"
    >
      <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
        <a-form-model-item
          ref="company"
          label="客户名称"
          prop="company"
          :help="formErr.company"
          :validateStatus="
            !formErr.company || formErr.company == '' ? '' : 'error'
          "
        >
          <a-input
            :maxLength="100"
            v-model="form.company"
            @change="
              (e) => {
                formErr.company = '';
              }
            "
            @blur="
              (e) => {
                form.company = e.target.value.trim();
              }
            "
            disabled
          />
        </a-form-model-item>

        <a-form-model-item
            ref="erp_contract_number"
            label="合同编号"
            prop="erp_contract_number"
            :help="formErr.erp_contract_number"
            :validateStatus="
            !formErr.erp_contract_number || formErr.erp_contract_number == '' ? '' : 'error'
          "
        >
          <!--        -->
          <a-input
              v-model="form.erp_contract_number"
              @change="
              (e) => {
                formErr.erp_contract_number = '';
              }
            "
              @blur="
              (e) => {
                form.erp_contract_number = e.target.value.trim();
              }
            "
              :disabled="disabled_customer_source"
          />
        </a-form-model-item>

        <a-form-model-item
          label="域名"
          prop="domain"
          ref="domain"
          :help="formErr.domain"
          :validateStatus="
            !formErr.domain || formErr.domain == '' ? '' : 'error'
          "
        >
          <a-input
            style="width: calc(100% - 90px);"
            v-model="form.domain"
            @change="
              (e) => {
                formErr.domain = '';
              }
            "
            @blur="
              (e) => {
                form.domain = e.target.value.trim();
              }
            "
          />
          <a-select
            style="width: 90px; float: left; margin-top: 4px;"
            v-model="form.protocol"
            @change="
              (e) => {
                formErr.protocol = '';
              }
            "
          >
            <a-select-option
              :value="item.value"
              :key="index"
              v-for="(item, index) in seleList.protocol"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="indsutry_ids"
          label="行业"
          prop="indsutry_ids"
          :help="formErr.indsutry_ids"
          :validateStatus="
            !formErr.indsutry_ids || formErr.indsutry_ids == '' ? '' : 'error'
          "
        >
          <a-cascader
            :load-data="loadData"
            :disabled="disabled_customer_source"
            :fieldNames="fieldNames"
            v-model="form.indsutry_ids"
            @change="
              (e) => {
                formErr.indsutry_ids = '';
              }
            "
            :options="seleList.industryList"
            change-on-select
            placeholder=""
          />
            <!--<a-select v-model="form.indsutry_ids "
                      @change="(e) => { formErr.indsutry_ids=''}">
                <a-select-option :value="item.id" :key="index" v-for="(item,index) in seleList.industryList">
                    {{item.name}}
                </a-select-option>
            </a-select>-->
        </a-form-model-item>
        <a-form-model-item
          ref="main_products"
          label="主营产品"
          prop="main_products"
          :help="formErr.main_products"
          :validateStatus="
            !formErr.main_products || formErr.main_products == '' ? '' : 'error'
          "
        >
          <a-input
            :maxLength="50"
            v-model="form.main_products"
            @change="
              (e) => {
                formErr.main_products = '';
              }
            "
            @blur="
              (e) => {
                form.main_products = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>

        <a-form-model-item
            ref="erp_website_version"
            label="ERP网站版本"
            prop="erp_website_version"
            :help="formErr.erp_website_version"
            :validateStatus="
            !formErr.erp_website_version || formErr.erp_website_version == '' ? '' : 'error'
          "
        >
          <a-input
              :disabled="disabled_customer_source"
              v-model="form.erp_website_version"
              @change="
              (e) => {
                formErr.erp_website_version = '';
              }
            "
              @blur="
              (e) => {
                form.erp_website_version = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>

        <a-form-model-item
          ref="a_version_id"
          label="合同版本"
          prop="a_version_id"
          :help="formErr.a_version_id"
          :validateStatus="
            !formErr.a_version_id || formErr.a_version_id == '' ? '' : 'error'
          "
        >
          <a-select
            v-model="form.a_version_id"
            @change="
              (e) => {
                formErr.a_version_id = '';
              }
            "
          >
            <a-select-option
              :value="item.id"
              :key="index"
              v-for="(item, index) in seleList.versionList"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="a_langset_id"
          label="主语种"
          prop="a_langset_id"
          :help="formErr.a_langset_id"
          :validateStatus="
            !formErr.a_langset_id || formErr.a_langset_id == '' ? '' : 'error'
          "
        >
          <a-radio-group v-model="form.a_langset_id">
            <!--                        :disabled="disabledlangset"-->
            <a-radio
              :value="item.id"
              :key="index"
              v-for="(item, index) in seleList.langsetList"
              >{{ item.name }}</a-radio
            >
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          ref="lang_name"
          label="小语种"
          prop="lang_name"
          :help="formErr.lang_name"
          :validateStatus="
            !formErr.lang_name || formErr.lang_name == '' ? '' : 'error'
          "
        >
          <a-input
            disabled
            :maxLength="100"
            :value="form.lang_num || ''"
            @change="
              (e) => {
                formErr.lang_name = '';
              }
            "
            @blur="
              (e) => {
                form.lang_name = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="lang_num"
          label="语种数量"
          prop="lang_num"
          :help="formErr.lang_num"
          :validateStatus="
            !formErr.lang_num || formErr.lang_num == '' ? '' : 'error'
          "
        >
          <!--<a-input :maxLength=4  v-model.number="form.lang_num " @change="(e) => { formErr.lang_num=''}"  />-->
          <a-input-number
            :min="1"
            style="width: 100%;"
            :maxLength="4"
            v-model="form.lang_num"
            :max="104"
            :precision="0"
          />
          <!--@change="(e) => { formErr.lang_num=''}" :precision="0" />-->
          <!--@blur="(e) => {  form.lang_num = e.target.value.trim();form.lang_num = e.target.value.replace(/^(0+)|[^\d]/g, '') }"-->
        </a-form-model-item>
        <a-form-model-item
          ref="translation_set_num"
          label="自动翻译字符数"
          prop="translation_set_num"
          :help="formErr.translation_set_num"
          :validateStatus="
            !formErr.translation_set_num || formErr.translation_set_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input-number
            :min="0"
            :max="99999"
            style="width: calc(100% - 35px);"
            :maxLength="5"
            v-model="form.translation_set_num"
            @change="
              (e) => {
                formErr.translation_set_num = '';
              }
            "
            :precision="0"
            disabled
          />
          <!--@blur="(e) => {  form.translation_set_num = e.target.value.trim();form.translation_set_num = e.target.value.replace(/^(0+)|[^\d]/g, '') }"-->
          <span style="width: 30px; float: right; text-align: center;">万</span>
        </a-form-model-item>
        <a-form-model-item
          ref="a_server_id"
          label="服务器"
          prop="a_server_id"
          :help="formErr.a_server_id"
          :validateStatus="
            !formErr.a_server_id || formErr.a_server_id == '' ? '' : 'error'
          "
        >
          <a-select
            v-model="form.a_server_id"
            @change="
              (e) => {
                formErr.a_server_id = '';
              }
            "
            :getPopupContainer="
              (triggerNode) => {
                return triggerNode.parentNode || document.body;
              }
            "
          >
            <a-select-option
              :value="item.id"
              :key="index"
              v-for="(item, index) in seleList.serverList"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="a_server_year_id"
          label="服务器年限"
          prop="a_server_year_id"
          :help="formErr.server_year"
          :validateStatus="
            !formErr.server_year || formErr.server_year == '' ? '' : 'error'
          "
        >
          <a-input-number
            style="width: calc(100% - 35px);"
            v-model="form.server_year"
            @change="
              (e) => {
                formErr.server_year = '';
              }
            "
            :precision="0"
            disabled
          />
          <!--@blur="(e) => {form.keyword_num = e.target.value.trim()}"-->
          <span style="width: 30px; float: right; text-align: center;">年</span>
        </a-form-model-item>
        <a-form-model-item
          ref="contact_person"
          label="联系人"
          prop="contact_person"
          :help="formErr.contact_person"
          :validateStatus="
            !formErr.contact_person || formErr.contact_person == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            :maxLength="50"
            v-model="form.contact_person"
            @change="
              (e) => {
                formErr.contact_person = '';
              }
            "
            @blur="
              (e) => {
                form.contact_person = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="nickname"
          label="昵称"
          prop="nickname"
          :help="formErr.nickname"
          :validateStatus="
            !formErr.nickname || formErr.nickname == '' ? '' : 'error'
          "
        >
          <a-input
            :maxLength="20"
            v-model="form.nickname"
            @change="
              (e) => {
                formErr.nickname = '';
              }
            "
            @blur="
              (e) => {
                form.nickname = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="email"
          label="邮箱"
          prop="email"
          :help="formErr.email"
          :validateStatus="!formErr.email || formErr.email == '' ? '' : 'error'"
        >
          <a-input
            v-model="form.email"
            @change="
              (e) => {
                formErr.email = '';
              }
            "
            @blur="
              (e) => {
                form.email = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="mobile"
          label="手机号"
          prop="mobile"
          :help="formErr.mobile"
          :validateStatus="
            !formErr.mobile || formErr.mobile == '' ? '' : 'error'
          "
        >
          <a-input
            :maxLength="11"
            v-model="form.mobile"
            @change="
              (e) => {
                formErr.mobile = '';
              }
            "
            @blur="
              (e) => {
                form.mobile = e.target.value.trim();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="password"
          label="密码"
          prop="password"
          :help="formErr.password"
          :validateStatus="
            !formErr.password || formErr.password == '' ? '' : 'error'
          "
        >
          <a-input
            style="width: calc(100% - 70px);"
            :disabled="disabled"
            v-model="form.password"
            @change="
              (e) => {
                formErr.password = '';
                form.password = password;
              }
            "
            @blur="
              (e) => {
                form.password = e.target.value.trim();
              }
            "
          />
          <a-button
            type="primary"
            style="width: 60px; float: right; margin-top: 4px;"
            @click="getPassword"
          >
            生成
          </a-button>
          <span
            style="
              position: absolute;
              width: calc(100% + 60px);
              right: -68px;
              top: 20px;
              text-align: right;
            "
            >注：生成后保存页面前请及时复制密码保存</span
          >
        </a-form-model-item>

        <a-form-model-item
          ref="activation_time"
          label="启用日期"
          prop="activation_time"
          :help="formErr.activation_time"
          :validateStatus="
            !formErr.activation_time || formErr.activation_time == ''
              ? ''
              : 'error'
          "
        >
          <a-date-picker
            :format="dateFormat"
            v-model="form.activation_time"
            @change="
              (value) => {
                getDueDate(value);
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          ref="online_time"
          label="上线日期"
          prop="online_time"
          :help="formErr.online_time"
          :validateStatus="
            !formErr.online_time || formErr.online_time == '' ? '' : 'error'
          "
        >
          <a-date-picker
            :format="dateFormat"
            v-model="form.online_time"
            disabled
          />
        </a-form-model-item>
        <a-form-model-item
          ref="expire_time"
          label="到期日期"
          prop="expire_time"
          :help="formErr.expire_time"
          :validateStatus="
            !formErr.expire_time || formErr.expire_time == '' ? '' : 'error'
          "
        >
          <a-date-picker
            :format="dateFormat"
            v-model="form.expire_time"
            disabled
          />
        </a-form-model-item>

        <!--<a-form-model-item
                ref="is_keyword"
                label="关键词排名"
                prop="is_keyword"
                :help="formErr.is_keyword"
                :validateStatus='!formErr.is_keyword||formErr.is_keyword==""?"":"error"'
        >
            <a-radio-group v-model="form.is_keyword">
                <a-radio :value="1"> 有</a-radio>
                <a-radio :value="0"> 无</a-radio>
            </a-radio-group>
            <span  style="position:absolute;width:400px;left: 0;top: 20px">（备注：修改选择为无时，已添加的项目和关键词清除）</span>
        </a-form-model-item>
        <div v-if="form.is_keyword==1">
            <a-form-model-item
                    ref="a_semalt_id"
                    label="Semalt账号"
                    prop="a_semalt_id"
                    :help="formErr.a_semalt_id"
                    :validateStatus='!formErr.a_semalt_id||formErr.a_semalt_id==""?"":"error"'
            >
                <a-select v-model="form.a_semalt_id " @change="(e) => { formErr.a_semalt_id=''}" :disabled="disabledSemalt">
                    <a-select-option :key="index" :value="item.id" v-for="(item ,index) in seleList.semaltList">
                        {{item.semalt_name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
        </div>-->
        <a-form-model-item
          ref="keyword_num"
          label="关键词数量"
          prop="keyword_num"
          :help="formErr.keyword_num"
          :validateStatus="
            !formErr.keyword_num || formErr.keyword_num == '' ? '' : 'error'
          "
        >
          <a-input-number
            style="width: 100%;"
            v-model="form.keyword_num"
            @change="
              (e) => {
                formErr.keyword_num = '';
              }
            "
            :precision="0"
          />
          <!--@blur="(e) => {form.keyword_num = e.target.value.trim() }"-->
        </a-form-model-item>

        <!--<a-form-model-item
                ref="business_opportunity_search_num"
                label="在线获客挖掘数量"
                prop="business_opportunity_search_num"
                :help="formErr.business_opportunity_search_num"
                :validateStatus='!formErr.business_opportunity_search_num||formErr.business_opportunity_search_num==""?"":"error"'
        >
            <a-input-number  style="width:100%; "
                    v-model="form.business_opportunity_search_num"
                    @change="(e) => {formErr.business_opportunity_search_num=''}"
                    @blur="(e) => {form.business_opportunity_search_num = e.target.value.trim() }"
                    :precision="0" :disabled="disabled_customer_source"
            />
        </a-form-model-item>-->
        <a-form-model-item
          ref="fb_num"
          label="Facebook商机挖掘数量"
          prop="fb_num"
          :help="formErr.fb_num"
          :validateStatus="
            !formErr.fb_num || formErr.fb_num == '' ? '' : 'error'
          "
        >
          <a-input-number
            style="width: 100%;"
            v-model="form.fb_num"
            @change="
              (e) => {
                formErr.fb_num = '';
              }
            "
            @blur="
              (e) => {
                form.fb_num = e.target.value.trim();
              }
            "
            :precision="0"
            :disabled="disabled_customer_source"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="linkedin_num"
          label="领英挖掘数量"
          prop="linkedin_num"
          :help="formErr.linkedin_num"
          :validateStatus="
            !formErr.linkedin_num || formErr.linkedin_num == '' ? '' : 'error'
          "
        >
          <a-input-number
            style="width: 100%;"
            :disabled="disabled_customer_source"
            v-model="form.linkedin_num"
            @change="
              (e) => {
                formErr.linkedin_num = '';
              }
            "
            @blur="
              (e) => {
                form.linkedin_num = e.target.value.trim();
              }
            "
            :precision="0"
          />
        </a-form-model-item>

        <a-form-model-item
          ref="google_map_num"
          label="Google地图挖掘数量"
          prop="google_map_num"
          :help="formErr.google_map_num"
          :validateStatus="
            !formErr.google_map_num || formErr.google_map_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            :disabled="disabled_customer_source"
            v-model="form.google_map_num"
            @change="
              (e) => {
                formErr.google_map_num = '';
              }
            "
            @blur="
              (e) => {
                form.google_map_num = e.target.value.trim();
              }
            "
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="search_engine_num"
          label="搜索引擎挖掘数量"
          prop="search_engine_num"
          :help="formErr.search_engine_num"
          :validateStatus="
            !formErr.search_engine_num || formErr.search_engine_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            :maxLength="4"
            v-model="form.search_engine_num"
            @change="
              (e) => {
                formErr.search_engine_num = '';
              }
            "
            @blur="
              (e) => {
                form.search_engine_num = e.target.value.trim();
              }
            "
            :precision="0"
            :disabled="disabled_customer_source"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="whatsapp_num"
          label="whatsapp挖掘数量"
          prop="whatsapp_num"
          :help="formErr.whatsapp_num"
          :validateStatus="
            !formErr.whatsapp_num || formErr.whatsapp_num == '' ? '' : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            :maxLength="5"
            :disabled="disabled_customer_source"
            v-model="form.whatsapp_num"
            @change="
              (e) => {
                formErr.whatsapp_num = '';
              }
            "
            @blur="
              (e) => {
                form.whatsapp_num = e.target.value.trim();
              }
            "
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="enterprise_num"
          label="企业信息挖掘数量"
          prop="enterprise_num"
          :help="formErr.enterprise_num"
          :validateStatus="
            !formErr.enterprise_num || formErr.enterprise_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            :maxLength="5"
            :disabled="disabled_customer_source"
            v-model="form.enterprise_num"
            @change="
              (e) => {
                formErr.enterprise_num = '';
              }
            "
            @blur="
              (e) => {
                form.enterprise_num = e.target.value.trim();
              }
            "
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="fb_watch_num"
          label="facebook监控数量"
          prop="fb_watch_num"
          :help="formErr.fb_watch_num"
          :validateStatus="
            !formErr.fb_watch_num || formErr.fb_watch_num == '' ? '' : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            :maxLength="5"
            :disabled="disabled_customer_source"
            v-model="form.fb_watch_num"
            @change="
              (e) => {
                formErr.fb_watch_num = '';
              }
            "
            @blur="
              (e) => {
                form.fb_watch_num = e.target.value.trim();
              }
            "
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="automated_marketing_num"
          label="自动化营销数量"
          prop="automated_marketing_num"
          :help="formErr.automated_marketing_num"
          :validateStatus="
            !formErr.automated_marketing_num ||
            formErr.automated_marketing_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            :maxLength="5"
            v-model="form.automated_marketing_num"
            @change="
              (e) => {
                formErr.automated_marketing_num = '';
              }
            "
            @blur="
              (e) => {
                form.automated_marketing_num = e.target.value.trim();
              }
            "
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="ai_employees_customer_num"
          label="AI员工获客次数"
          prop="ai_employees_customer_num"
          :help="formErr.ai_employees_customer_num"
          :validateStatus="
            !formErr.ai_employees_customer_num ||
            formErr.ai_employees_customer_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            v-model="form.ai_employees_customer_num"
            :disabled="true"
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="ai_optimize_num"
          label="AI优化次数"
          prop="ai_optimize_num"
          :help="formErr.ai_optimize_num"
          :validateStatus="
            !formErr.ai_optimize_num || formErr.ai_optimize_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            v-model="form.ai_optimize_num"
            :disabled="true"
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="ai_image_matting_num"
          label="AI抠图次数"
          prop="ai_image_matting_num"
          :help="formErr.ai_image_matting_num"
          :validateStatus="
            !formErr.ai_image_matting_num || formErr.ai_image_matting_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            v-model="form.ai_image_matting_num"
            :disabled="true"
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="ai_video_time"
          label="AI视频时长"
          prop="ai_video_time"
          :help="formErr.ai_video_time"
          :validateStatus="
            !formErr.ai_video_time || formErr.ai_video_time == '' ? '' : 'error'
          "
        >
          <a-input
            style="width: 100%;"
            v-model="form.ai_video_time"
            :disabled="true"
            :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
            ref="customer_service_num"
            label="智能客服次数"
            prop="customer_service_num"
            :help="formErr.customer_service_num"
            :validateStatus="
            !formErr.customer_service_num || formErr.customer_service_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
              style="width: 100%;"
              v-model="form.customer_service_num"
              :disabled="disabled_customer_source"
              @change="
              (e) => {
                formErr.customer_service_num = '';
              }
            "
              @blur="
              (e) => {
                form.customer_service_num = e.target.value.trim();
              }
            "
              :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
            label="策略报告"
        >
          <a-input
              style="width: 100%;"
              v-model="promotion_marketing_num"
              :disabled=true
              :precision="0"
          />
        </a-form-model-item>

        <a-form-model-item
            label="阶段报告"
        >
          <a-input
              style="width: 100%;"
              v-model="phase_strategy_num"
              :disabled=true
              :precision="0"
          />
        </a-form-model-item>

        <a-form-model-item
            label="Facebook账号数量"
        >
          <a-input
              style="width: 100%;"
              v-model="form.facebook_account_num"
              :disabled="disabled_customer_source"
              :precision="0"
          />
        </a-form-model-item>

        <a-form-model-item
            label="Instagram账号数量"
        >
          <a-input
              style="width: 100%;"
              v-model="form.instagram_account_num"
              :disabled="disabled_customer_source"
              :precision="0"
          />
        </a-form-model-item>

        <a-form-model-item
            label="Linkedin账号数量"
        >
          <a-input
              style="width: 100%;"
              v-model="form.linkedin_account_num"
              :disabled="disabled_customer_source"
              :precision="0"
          />
        </a-form-model-item>

        <a-form-model-item
            ref="segmentation_time"
            label="视频自定义分割时长"
            prop="segmentation_time"
            :help="formErr.segmentation_time"
            :validateStatus="
            !formErr.segmentation_time || formErr.segmentation_time == '' ? '' : 'error'
          "
        >
          <a-input
              style="width: 100%;"
              v-model="form.segmentation_time"
              :disabled="true"
              @change=" (e) => {formErr.segmentation_time = '';  }"
              :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
            ref="google_ad_planning_num"
            label="Google广告投放策划次数："
            prop="google_ad_planning_num"
            :help="formErr.google_ad_planning_num"
            :validateStatus="
            !formErr.google_ad_planning_num || formErr.google_ad_planning_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
              style="width: 100%;"
              v-model="form.google_ad_planning_num"
              :disabled="true"
              @change="
              (e) => {
                formErr.google_ad_planning_num = '';
              }
            "
              @blur="
              (e) => {
                form.google_ad_planning_num = e.target.value.trim();
              }
            "
              :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
            ref="google_landing_page_num"
            label="Google 广告着陆页智能生成次数："
            prop="google_landing_page_num"
            :help="formErr.google_landing_page_num"
            :validateStatus="
            !formErr.google_landing_page_num || formErr.google_landing_page_num == ''
              ? ''
              : 'error'
          "
        >
          <a-input
              style="width: 100%;"
              v-model="form.google_landing_page_num"
              :disabled="true"
              @change="
              (e) => {
                formErr.google_landing_page_num = '';
              }
            "
              @blur="
              (e) => {
                form.google_landing_page_num = e.target.value.trim();
              }
            "
              :precision="0"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="is_crm"
          label="CRM/客户管理"
          prop="is_crm"
          :help="formErr.is_crm"
          :validateStatus="
            !formErr.is_crm || formErr.is_crm == '' ? '' : 'error'
          "
        >
          <a-radio-group v-model="form.is_crm">
            <a-radio
              :value="item.value"
              :key="index"
              v-for="(item, index) in seleList.is_crm"
            >
              {{ item.name }}</a-radio
            >
          </a-radio-group>
        </a-form-model-item>
        <!--<a-form-model-item
                ref="is_crm"
                label="是否有邮件和CRM"
                prop="is_crm"
                :help="formErr.is_crm"
                :validateStatus='!formErr.is_crm||formErr.is_crm==""?"":"error"'
        >
            <a-radio-group v-model="form.is_crm">
                <a-radio :value="1"> 是</a-radio>
                <a-radio :value="0"> 否</a-radio>
            </a-radio-group>
        </a-form-model-item>-->
        <a-form-model-item
          ref="order_message_type  "
          label="订单报文"
          prop="order_message_type  "
          :help="formErr.order_message_type"
          :validateStatus="
            !formErr.order_message_type || formErr.order_message_type == ''
              ? ''
              : 'error'
          "
        >
          <a-radio-group v-model="form.order_message_type">
            <a-radio
              :value="item.value"
              :key="index"
              v-for="(item, index) in seleList.orderMessageTypeList"
            >
              {{ item.name }}</a-radio
            >
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          ref="site_type"
          label="网站类型"
          prop="site_type"
          :help="formErr.site_type"
          :validateStatus="
            !formErr.site_type || formErr.site_type == '' ? '' : 'error'
          "
        >
          <a-select
            v-model="form.site_type"
            @change="
              (e) => {
                formErr.site_type = '';
              }
            "
            disabled
          >
            <a-select-option
              :value="item.value"
              :key="index"
              v-for="(item, index) in seleList.siteTypeList"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!--<a-form-model-item
            ref="a_team_customer_service_id"
            label="客户地区"
            prop="a_team_customer_service_id"
            :help="formErr.a_team_customer_service_id"
            :validateStatus='!formErr.a_team_customer_service_id||formErr.a_team_customer_service_id==""?"":"error"'
        >
          <a-select v-model="form.a_team_customer_service_id" @change="(e) => { formErr.a_team_customer_service_id=''}">
            <a-select-option  :value="item.value" :key="index" v-for="(item,index) in seleList.team" :disabled="item.status!=1">
              {{item.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>-->
        <a-form-model-item
          ref="type"
          label="客户类型"
          prop="type"
          :help="formErr.type"
          :validateStatus='!formErr.type||formErr.type==""?"":"error"'
        >
        <a-radio-group v-model="form.type" @change="changeType">
          <a-radio v-for="(item, index) in seleList.type" :value="item.value" :key="index"> {{item.name}}</a-radio>
          <!--<a-radio :value="1"> 正式</a-radio>
          <a-radio :value="2"> 验收</a-radio>
          <a-radio :value="3"> 代理</a-radio>-->
        </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-if="form.type == 3"
          ref="a_agent_id"
          label="代理商"
          prop="a_agent_id"
          :help="formErr.a_agent_id"
          :validateStatus="
        !formErr.a_agent_id || formErr.a_agent_id == '' ? '' : 'error'
        "
        >
          <a-select
              v-model="form.a_agent_id"
              @change="
          (e) => {
            formErr.a_agent_id = '';
          }
        "
          >
              <a-select-option
                  :value="item.id"
                  :key="index"
                  v-for="(item, index) in seleList.agentList"
              >
                  {{ item.name }}
              </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item
          ref="product_page_data"
          label="产品导航调取"
          prop="product_page_data"
          :help="formErr.product_page_data"
          :validateStatus="
            !formErr.product_page_data || formErr.product_page_data == ''
              ? ''
              : 'error'
          "
        >
          <a-radio-group v-model="form.product_page_data">
            <a-radio :value="1"> 产品列表</a-radio>
            <a-radio :value="2"> 产品分类</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item
            ref="is_open_mobile_banner"
            label="移动端传图"
            prop="is_open_mobile_banner"
            :help="formErr.is_open_mobile_banner"
            :validateStatus="
            !formErr.is_open_mobile_banner || formErr.is_open_mobile_banner == ''
              ? ''
              : 'error'
          "
        >
          <a-radio-group v-model="form.is_open_mobile_banner">
            <a-radio :value="1"> 开启</a-radio>
            <a-radio :value="2"> 关闭</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item
          ref="status"
          label="状态"
          prop="status"
          :help="formErr.status"
          :validateStatus="
            !formErr.status || formErr.status == '' ? '' : 'error'
          "
        >
          <a-radio-group v-model="form.status">
            <a-radio :value="1"> 启用</a-radio>
            <a-radio :value="0"> 停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          ref="is_open_chatgpt"
          label="AIChat"
          prop="is_open_chatgpt"
          :help="formErr.is_open_chatgpt"
          :validateStatus="
            !formErr.is_open_chatgpt || formErr.is_open_chatgpt == ''
              ? ''
              : 'error'
          "
        >
          <a-radio-group v-model="form.is_open_chatgpt">
            <a-radio :value="1"> 开启</a-radio>
            <a-radio :value="2"> 关闭</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          ref="type"
          label="是否开启webp按钮"
          prop="is_open_webp"
          :help="formErr.is_open_webp"
          :validateStatus="
            !formErr.is_open_webp || formErr.is_open_webp == '' ? '' : 'error'
          "
        >
          <a-radio-group v-model="form.is_open_webp">
            <a-radio :value="item.value" v-for="(item, idx) in seleList.is_open_webp" :key="idx">
              {{ item.name }}</a-radio
            >
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
            ref="type"
            label="谷歌代码网关"
            prop="gtg_status"
            :help="formErr.gtg_status"
            :validateStatus="
            !formErr.gtg_status || formErr.gtg_status == '' ? '' : 'error'
          "
        >
          <a-radio-group v-model="form.gtg_status"  >
            <a-radio :value="item.value" v-for="(item, idx) in seleList.gtgStatusList" :key="idx">
              {{ item.name }} </a-radio
            >
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
            ref="type"
            label="邮件通知logo"
            prop="inquiry_email_logo_status"
            :help="formErr.inquiry_email_logo_status"
            :validateStatus="
            !formErr.inquiry_email_logo_status || formErr.inquiry_email_logo_status == '' ? '' : 'error'
          "
        >
          <a-radio-group v-model="form.inquiry_email_logo_status"  >
            <a-radio :value="item.value" v-for="(item, idx) in seleList.inquiryEmailLogoStatusList" :key="idx">
              {{ item.name }} </a-radio
            >
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
            ref="template_type"
            label="可视化版本"
            prop="template_type"
            :help="formErr.template_type"
            :validateStatus="
            !formErr.template_type || formErr.template_type == '' ? '' : 'error'
          "
        >
          <!--        {{seleList}}-->
          <a-radio-group v-model="form.template_type" @change="form.ksh_theme_color=''">
            <a-radio :value="item.value" v-for="(item, idx) in seleList.templateTypeList" :key="idx">
              {{ item.name }}</a-radio
            >
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.template_type==2"
                           ref="ksh_theme_color"
                           label="公共页面主题色"
                           prop="ksh_theme_color"
                           :help="formErr.ksh_theme_color"
                           :validateStatus="
            !formErr.ksh_theme_color || formErr.ksh_theme_color == '' ? '' : 'error'
          "
        >
          <!--<chrome-color-picker v-model="form.ksh_theme_color"  @change="(c)=>{ formErr.ksh_theme_color=''}"></chrome-color-picker>-->
          <span class="theme-color-picker-wrap" @paste="onThemeColorPaste" @keydown.enter="onThemeColorCommit" @change="onThemeColorCommit">
            <el-color-picker style="position: relative;top: 5px"  @change="(c)=>{form.ksh_theme_color=c=='#aN'?'':c;formErr.ksh_theme_color=''}" :value="form.ksh_theme_color"  ></el-color-picker>
          </span>

          <!--<el-color-picker  v-model="form.ksh_theme_color"  @change="(c)=>{ formErr.ksh_theme_color=''}"></el-color-picker>
          <a-input type="color" v-model="form.ksh_theme_color"  @change="(c)=>{ formErr.ksh_theme_color=''}"></a-input>
          <el-color-picker style="position: relative;top: 5px"  @change="(c)=>{form.ksh_theme_color=c=='#aN'?'':c;formErr.ksh_theme_color=''}" :value="form.ksh_theme_color"  ></el-color-picker>-->
     </a-form-model-item>

      <a-form-model-item
        ref="erp_remark"
        label="备注"
        prop="erp_remark"
        :help="formErr.erp_remark"
        :validateStatus="
          !formErr.erp_remark || formErr.erp_remark == '' ? '' : 'error'
        "
        v-if="form.erp_remark"
      >
        <a-input
          :disabled="disabled"
          v-model="form.erp_remark"
          @change="
            (e) => {
              formErr.erp_remark = '';
            }
          "
          @blur="
            (e) => {
              form.erp_remark = e.target.value.trim();
            }
          "
        />
      </a-form-model-item>
      </a-form-model>

      <div class="drawer-btn">
        <a-button
          type="primary"
          @click="onSubmit"
          :style="{ marginRight: '8px' }"
        >
          确定
        </a-button>
        <a-button @click="onClose">
          取消
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { submitForm, drawerConfig, validator } from "../../../utils/utils";
import API from "../api";
import moment from "moment";

export default {
  name: "openCustomers",
  props: ["visibleForm", "titleForm", "openCustomersId"],

  data() {
    let validator2 = (rule, value, callback, errval) => {
      let formerrname = rule.field;
      var str = new RegExp("http");
      if (errval != "") {
        callback(new Error(errval));
      } else if (str.test(this.form.domain)) {
        this.formErr.domain = "域名中不能包含http或https";
        callback();
      } else {
        this.formErr.domain = "";
        this.formErr.domain = "";
        callback();
      }
    };
    let validator3 = (rule, value, callback, errval) => {
      let formerrname = rule.field;
      let pattern = /[\u4E00-\u9FA5]/;
      // /[\x7f-\xff]/
      if (errval != "") {
        callback(new Error(errval));
      } else if (pattern.test(this.form.nickname)) {
        // this.formErr.nickname="6-20字符 字母 数字 特殊符号"
        callback("20字符以内，字母、数字或特殊符号");
      } else {
        this.formErr.nickname = "";
        callback();
      }
    };
    return {
      fieldNames: { label: "name", value: "id", children: "children" },
      disabledlangset: false,
      disabledSemalt: false,
      disabled: true,
      drawerConfig,
      dateFormat: "YYYY-MM-DD",
      disabled_customer_source: false,
      promotion_marketing_num: 0,
      phase_strategy_num: 0,
      facebook_account_num: 0,
      instagram_account_num: 0,
      linkedin_account_num: 0,
      form: {
        company: "",
        erp_contract_number: "",
        protocol: "http://",
        domain: "",
        indsutry_ids: [],
        main_products: "",
        a_version_id: "",
        a_langset_id: "",
        // a_langset_id: 1,
        lang_num: "",
        translation_set_num: "",
        a_server_id: "",
        server_year: "",
        contact_person: "",
        nickname: "",
        email: "",
        mobile: "",
        password: "",
        type: 1,
        status: 1,
        is_crm: 1,
        a_agent_id: "",
        is_open_webp: 1, // is_keyword: 1,
        is_open_chatgpt: 1,
        site_type: "",
        // a_semalt_id: "",
        keyword_num: "50",
        activation_time: moment(new Date(), "YYYY-MM-DD"),
        online_time: null,
        expire_time: null,
        // business_opportunity_search_num:50,
        fb_num: 50,
        // a_team_customer_service_id:"",
        order_message_type: 0,
        linkedin_num: "",
        google_map_num: "",
        customer_service_num: 0,
        search_engine_num: 50,
        whatsapp_num: 50,
        enterprise_num: 50,
        fb_watch_num: 50,
        automated_marketing_num: 5000,
        ai_optimize_num: 0,
        ai_image_matting_num: 0,
        ai_video_time: 0,
        google_ad_planning_num: 0,
        google_landing_page_num: 0,
        segmentation_time: 0,
        product_page_data: 1,
        is_open_mobile_banner:2,
        template_type:1,
        inquiry_email_logo_status:1,
        gtg_status:2,
        ksh_theme_color:'',
        erp_website_version:'',
      },
      formErr: {
        company: "",
        erp_contract_number: "",
        protocol: "",
        domain: "",
        indsutry_ids: "",
        main_products: "",
        a_version_id: "",
        a_langset_id: "",
        lang_num: "",
        translation_set_num: "",
        a_server_id: "",
        server_year: "",
        contact_person: "",
        nickname: "",
        email: "",
        mobile: "",
        password: "",
        type: "",
        status: "",
        is_crm: "",
        site_type: "",
        is_open_webp: "",
        is_open_chatgpt: "",
        a_agent_id: "",
        // is_keyword: "",
        // a_semalt_id: "",
        keyword_num: "",
        activation_time: "",
        online_time: "",
        expire_time: "",
        // business_opportunity_search_num:"",
        fb_num: "",
        // a_team_customer_service_id:"",
        order_message_type: "",
        linkedin_num: "",
        google_map_num: "",
        search_engine_num: "",
        whatsapp_num: "",
        enterprise_num: "",
        fb_watch_num: "",
        automated_marketing_num: "",
        ai_optimize_num: "",
        ai_image_matting_num: "",
        ai_video_time: "",
        google_ad_planning_num: "",
        google_landing_page_num: "",
        product_page_data: "",
        is_open_mobile_banner: "",
        segmentation_time: "",
        template_type:'',
        ksh_theme_color:'',
        erp_website_version:'',
        inquiry_email_logo_status:'',
        gtg_status:'',
        customer_service_num: ""
      },
      seleList: [],
      rules: {
        company: [
          { required: true, message: "请输入客户名称 " },
          {
            whitespace: true,
            message: "请输入客户名称 "
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.company);
            },
            trigger: "blur"
          }
        ],
        domain: [
          { required: true, message: "请输入域名 " },
          {
            whitespace: true,
            message: "请输入域名名称 "
          },
          {
            validator: (rule, value, callback) => {
              validator2(rule, value, callback, this.formErr.domain);
            },
            trigger: "blur"
          }
        ],
        indsutry_ids: [
          {
            required: true,
            message: "请选择行业 "
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.indsutry_ids);
            },
            trigger: "blur"
          }
        ],
        main_products: [
          { required: true, message: "请输入主营产品 " },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.main_products);
            },
            trigger: "blur"
          }
        ],
        a_version_id: [
          { required: true, message: "请输入合同版本 " },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.a_version_id);
            },
            trigger: "blur"
          }
        ],
        // a_langset_id: [{required: true, message: "请输入主语种 ",}, {
        //     validator: (rule, value, callback) => {
        //         validator(rule, value, callback, this.formErr.a_langset_id)
        //     }, trigger: "blur"
        // }],

        a_agent_id: [
          {
            required: false,
            message: "请选择代理商",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.a_agent_id);
            },
            trigger: ["blur", "change"]
          }
        ],

        lang_num: [
          { required: true, message: "请输入语种数量 " },
          { type: "integer", message: "请输入正整数", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.lang_num);
            },
            trigger: "blur"
          }
        ],
        translation_set_num: [
          {
            required: true,
            message: "请输入自动翻译字符数 "
          },
          {
            validator: (rule, value, callback) => {
              validator(
                rule,
                value,
                callback,
                this.formErr.translation_set_num
              );
            },
            trigger: "blur"
          }
        ],
        a_server_id: [
          { required: true, message: "请输入服务器 " },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.a_server_id);
            },
            trigger: "blur"
          }
        ],
        server_year: [
          { required: true, message: "请输入服务器年限 " },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.a_server_year_id);
            },
            trigger: "blur"
          }
        ],
        contact_person: [
          { required: true, message: "请输入联系人 " },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.contact_person);
            },
            trigger: "blur"
          }
        ],
        nickname: [
          { required: true, message: "请输入昵称 " },
          {
            max: 20,
            message: "20字符以内，字母、数字或特殊符号"
          },
          {
            validator: (rule, value, callback) => {
              validator3(rule, value, callback, this.formErr.nickname);
            },
            trigger: "blur"
          }
        ],
        email: [
          { required: true, message: "请输入邮箱 " },
          {
            type: "email",
            message: "请填写正确邮箱"
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.email);
            },
            trigger: "blur"
          }
        ],
        mobile: [
          { required: true, message: "请输入手机号 " },
          { pattern: /^(?:(?:\+|00)86)?1\d{10}$/, message: "请填写正确手机号" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.mobile);
            },
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码.", trigger: ["change"] },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.password);
            },
            trigger: "blur"
          }
        ],
        activation_time: [
          { required: true, message: "请输入启用日期 " },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.activation_time);
            },
            trigger: "blur"
          }
        ],
        expire_time: [
          { required: true, message: "请输入到期日期 " },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.expire_time);
            },
            trigger: "blur"
          }
        ],

        // a_semalt_id: [{
        //     required: true,
        //     message: "请输入Semalt账号 ",
        //     trigger: "blur"
        // }, {
        //     validator: (rule, value, callback) => {
        //         validator(rule, value, callback, this.formErr.a_semalt_id)
        //     }, trigger: "blur"
        // }],
        keyword_num: [
          {
            required: true,
            message: "请输入关键词数量 ",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.keyword_num);
            },
            trigger: "blur"
          }
        ],

        // business_opportunity_search_num: [{
        //     required: true,
        //     message: "请输入在线获客数量",
        //     trigger: "blur"
        // }, {
        //     validator: (rule, value, callback) => {
        //         validator(rule, value, callback, this.formErr.business_opportunity_search_num)
        //     }, trigger: "blur"
        // }],
        fb_num: [
          {
            required: true,
            message: "请输入Facebook商机挖掘数量",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.fb_num);
            },
            trigger: "blur"
          }
        ],
        linkedin_num: [
          {
            required: true,
            message: "请输入领英挖掘数量",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.linkedin_num);
            },
            trigger: "blur"
          }
        ],
        google_map_num: [
          {
            required: true,
            message: "请输入Google地图挖掘数量",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.google_map_num);
            },
            trigger: "blur"
          }
        ],
        search_engine_num: [
          {
            required: true,
            message: "请输入搜索引擎挖掘数量",
            trigger: "blur"
          },
          { pattern: /^[0-9]\d*$/, message: "请输入非负整数" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.search_engine_num);
            },
            trigger: "blur"
          }
        ],
        whatsapp_num: [
          {
            required: true,
            message: "请输入whatsapp挖掘数量",
            trigger: "blur"
          },
          { pattern: /^[0-9]\d*$/, message: "请输入非负整数" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.whatsapp_num);
            },
            trigger: "blur"
          }
        ],
        enterprise_num: [
          {
            required: true,
            message: "请输入企业信息挖掘数量",
            trigger: "blur"
          },
          { pattern: /^[0-9]\d*$/, message: "请输入非负整数" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.enterprise_num);
            },
            trigger: "blur"
          }
        ],
        fb_watch_num: [
          {
            required: true,
            message: "请输入facebook监控数量",
            trigger: "blur"
          },
          { pattern: /^[0-9]\d*$/, message: "请输入非负整数" },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.fb_watch_num);
            },
            trigger: "blur"
          }
        ],
        automated_marketing_num: [
          {
            required: true,
            message: "请输入自动化营销数量",
            trigger: "blur"
          },
          { pattern: /^[0-9]\d*$/, message: "请输入非负整数" },
          {
            validator: (rule, value, callback) => {
              validator(
                rule,
                value,
                callback,
                this.formErr.automated_marketing_num
              );
            },
            trigger: "blur"
          }
        ],
        site_type: [
          //     {
          //     required: true,
          //     message: "请选择网站类型",
          //     trigger: "blur"
          // },
          {
            validator: (rule, value, callback) => {
              validator(rule, value, callback, this.formErr.site_type);
            },
            trigger: "blur"
          }
        ]
        // a_team_customer_service_id: [{
        //   required: true,
        //   message: "请选择客户地区",
        //   trigger: "blur"
        // }, {
        //   validator: (rule, value, callback) => {
        //     if (this.formErr.a_team_customer_service_id == undefined){
        //       this.formErr.a_team_customer_service_id =""
        //     }
        //     validator(rule, value, callback,this.formErr.a_team_customer_service_id)
        //   }, trigger: "blur"
        // }],
      },
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 }
      }
    };
  },
  watch: {
    visibleForm: function (a, b) {
      console.log(this.openCustomersId);
      // if(a)this.getFormData()
    },
    openCustomersId: function (a, b) {
      if (a != "") {
        // this.getFormData()
        let THAT = this;
        API.customer.OPEN_EDIT_DATA(a).then((res) => {
          let val = res.data.data.info;
          val.activation_time =
            res.data.data.info.activation_time == ""
              ? moment(new Date(), "YYYY-MM-DD")
              : moment(res.data.data.info.activation_time, "YYYY-MM-DD");
          val.online_time =
            res.data.data.info.online_time == ""
              ? null
              : moment(res.data.data.info.online_time, "YYYY-MM-DD");
          val.expire_time =
            res.data.data.info.expire_time == ""
              ? null
              : moment(res.data.data.info.expire_time, "YYYY-MM-DD");
          val.password = val.password || "";
          this.form = val;
          this.promotion_marketing_num = res.data.data.promotion_marketing_num;
          this.phase_strategy_num = res.data.data.phase_strategy_num;
          this.facebook_account_num = res.data.data.facebook_account_num;
          this.instagram_account_num = res.data.data.instagram_account_num;
          this.linkedin_account_num = res.data.data.linkedin_account_num;
          this.form.translation_set_num = val.translation_set_num / 10000;
          this.form.id = a;
          this.form.type == 3
            ? (this.rules.a_agent_id[0].required = true)
            : (this.rules.a_agent_id[0].required = false);
          // this.form.a_customer_industry_id = val.a_customer_industry_id*1
          // val.a_customer_industry_id==0?this.form.a_customer_industry_id='':this.form.a_customer_industry_id=val.a_customer_industry_id
          val.a_version_id == 0
            ? (this.form.a_version_id = "")
            : (this.form.a_version_id = val.a_version_id);
          val.a_server_id == 0
            ? (this.form.a_server_id = "")
            : (this.form.a_server_id = val.a_server_id);
          val.a_server_year_id == 0
            ? (this.form.a_server_year_id = "")
            : (this.form.a_server_year_id = val.a_server_year_id);
          // val.a_semalt_id==0?this.form.a_semalt_id='':this.form.a_semalt_id=val.a_semalt_id
          val.site_type == 0
            ? (this.form.site_type = "")
            : (this.form.site_type = val.site_type);

          this.getDueDate(this.form.activation_time, this.form.server_year);
          this.seleList = res.data.data;
          this.disabledlangset = true;
          // if(this.form.is_keyword==1){
          //     this.disabledSemalt=true
          //     // this.form.a_semalt_id=val.a_semalt_id
          //     this.form.keyword_num=val.keyword_num
          // }else{
          //     this.disabledSemalt=false
          //     // this.form.a_semalt_id=""
          //     this.form.keyword_num=50
          // }
          this.rules.password = [
            { required: false, message: "请输入密码 ", trigger: ["change"] },
            {
              validator: (rule, value, callback) => {
                validator(rule, value, callback, this.formErr.password);
              },
              trigger: "blur"
            }
          ];
          this.form.password = "";
          if (this.form.customer_source == 2) {
            this.disabled_customer_source = true;
          }
          this.$nextTick().then(function () {
            THAT.form.indsutry_ids = res.data.data.info.indsutry_ids;
          });
          // this.form.password="***"
        });
      } else {
        this.form.id = "";
      }
    }
  },
  mounted() {
    // this.getFormData()
  },
  methods: {
    changeType() {
      this.form.type == 3
        ? (this.rules.a_agent_id[0].required = true)
        : (this.rules.a_agent_id[0].required = false);
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      let THAT = this;
      API.customer
        .GET_INDUSTRY_LIST({
          parent_id: selectedOptions[selectedOptions.length - 1].id
        })
        .then((res) => {
          targetOption.loading = false;
          targetOption.children = res.data.data;
          THAT.seleList.industryList = [...THAT.seleList.industryList];
        });
    },
    getDueDate(data, year) {
      API.customer
        .OPEN_DUE_DATE({
          activation_time: moment(data).format("YYYY-MM-DD"),
          server_year: this.form.server_year
        })
        .then((res) => {
          this.form.expire_time =
            res.data.data.expire_time == ""
              ? null
              : moment(res.data.data.expire_time, "YYYY-MM-DD");
        });
    },
    getPassword() {
      API.customer.GET_PASSWORD().then((res) => {
        this.disabled = false;
        this.form.password = res.data.data.password;
        this.password = res.data.data.password;
        this.formErr.password = "";
        this.$refs.ruleForm.validateField("password", (contentError) => {
          if (!phoneError) {
            //当校验通过时，这里面写逻辑代码
            this.formErr.password = "";
          }
        });
      });
    },
    getFormData() {
      API.customer.ADD_DATA().then((res) => {
        this.seleList = res.data.data;
      });
    },
    onClose() {
      this.$emit("changVisible", false);
      this.$refs.ruleForm.resetFields();
      this.disabledlangset = false;
      (this.rules.password = [
        { required: true, message: "请输入密码 ", trigger: ["change"] },
        {
          validator: (rule, value, callback) => {
            validator(rule, value, callback, this.formErr.password);
          },
          trigger: "blur"
        }
      ]),
        (this.disabledSemalt = false),
        (this.disabled = true),
        (this.promotion_marketing_num = 0),
        (this.phase_strategy_num = 0),
        (this.facebook_account_num = 0),
        (this.instagram_account_num = 0),
        (this.linkedin_account_num = 0),
        (this.form = {
          company: "",
          erp_contract_number: "",
          protocol: "http://",
          domain: "",
          indsutry_ids: [],
          main_products: "",
          a_version_id: "",
          a_langset_id: 1,
          lang_num: "",
          translation_set_num: "",
          a_server_id: "",
          server_year: "",
          contact_person: "",
          nickname: "",
          email: "",
          mobile: "",
          password: "",
          type: 1,
          status: 1,
          is_crm: 1,
          is_open_webp: 1,
          is_open_chatgpt: 1,
          // is_keyword: 1,
          site_type: "",
          // a_semalt_id: "",
          keyword_num: "50",
          activation_time: moment(new Date(), "YYYY-MM-DD"),
          online_time: null,
          expire_time: null,
          // business_opportunity_search_num:50,
          linkedin_num: "",
          google_map_num: "",
          customer_service_num: 0,
          fb_num: 50,
          order_message_type: 0,
          search_engine_num: 50,
          whatsapp_num: 50,
          enterprise_num: 50,
          fb_watch_num: 50,
          automated_marketing_num: 5000,
          ai_employees_customer_num: 5, // AI员工获客次数
          ai_optimize_num: 0,
          ai_image_matting_num: 0,
          ai_video_time: 0,
          product_page_data: 1,
          is_open_mobile_banner:2,
          segmentation_time: 0,
          template_type:1,
          inquiry_email_logo_status:1,
          gtg_status:2,
          ksh_theme_color:'',
          erp_website_version:'',
        });
      this.formErr = {
        company: "",
        erp_contract_number: "",
        protocol: "",
        domain: "",
        indsutry_ids: "",
        main_products: "",
        a_version_id: "",
        a_langset_id: "",
        lang_num: "",
        translation_set_num: "",
        a_server_id: "",
        server_year: "",
        contact_person: "",
        nickname: "",
        email: "",
        mobile: "",
        password: "",
        type: "",
        status: "",
        is_crm: "",
        site_type: "",
        is_open_webp: "",
        is_open_chatgpt: "",
        a_agent_id: "",
        // is_keyword: "",
        // a_semalt_id: "",
        keyword_num: "",
        activation_time: "",
        online_time: "",
        expire_time: "",
        // business_opportunity_search_num:"",
        fb_num: "",
        // a_team_customer_service_id:"",
        order_message_type: "",
        linkedin_num: "",
        google_map_num: "",
        search_engine_num: "",
        whatsapp_num: "",
        enterprise_num: "",
        fb_watch_num: "",
        automated_marketing_num: "",
        ai_employees_customer_num: "",
        ai_optimize_num: "",
        ai_image_matting_num: "",
        ai_video_time: "",
        customer_service_num: "",
        product_page_data: "",
        is_open_mobile_banner:'',
        segmentation_time: "",
        template_type:'',
        erp_website_version:'',
        inquiry_email_logo_status:'',
        gtg_status:'',
        ksh_theme_color:''
      };
    },
    onSubmit() {
      let _this = this;
      let formData = JSON.parse(JSON.stringify(this.form));
      formData.activation_time != "" && formData.activation_time != null
        ? (formData.activation_time = moment(formData.activation_time).format(
            "YYYY-MM-DD"
          ))
        : (formData.activation_time = null);
      formData.online_time != "" && formData.online_time != null
        ? (formData.online_time = moment(formData.online_time).format(
            "YYYY-MM-DD"
          ))
        : (formData.online_time = null);
      formData.expire_time != "" && formData.expire_time != null
        ? (formData.expire_time = moment(formData.expire_time).format(
            "YYYY-MM-DD"
          ))
        : (formData.expire_time = null);

      // if (formData.id && formData.id != '') {
      //     formData.password == "***" ? formData.password="" : formData.password == formData.password
      // }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          API.customer
            .FB_EXIST_CUSTOMER({ email: this.form.email })
            .then((res) => {
              if (res.data.code == 1) {
                const h = this.$createElement;
                this.$confirm({
                  title: "确认提示",
                  content: h("div", {}, [
                    h("span", res.data.data.msg),
                    h("p", res.data.data.msg1)
                  ]),
                  onOk() {
                    _this.submitForm(formData);
                  },
                  onCancel() {}
                });
                return;
              }
              this.submitForm(formData);
            });
        } else {
        }
      });
    },
    submitForm(formData) {
      let url = API.customer.CUSTOMER_SUBMIT_ADD;
      submitForm(url, formData).then((res) => {
        if (res == true) {
          this.onClose();
        } else {
          res.map((item, index) => {
            this.formErr[item.field] = item.msg;
          });
        }
      });
    },
    elColorPickerChange(data){
      console.log("elColorPickerChange",data)
      this.formErr.ksh_theme_color=''
      this.form.ksh_theme_color=data=='#aN'?'':data
      // this.form.ksh_theme_color=data
    },
    // el-color-picker 弹出层内色值输入框：粘贴后同步色值
    onThemeColorPaste(e) {
      // 粘贴事件触发时输入框尚未写入新值，延后读取；先取出 DOM 引用防止异步闭包丢失
      const input = e.target;
      setTimeout(() => {
        this.applyThemeColorInput(input);
      }, 0);
    },
    // el-color-picker 弹出层内色值输入框：回车/失焦(原生change)后同步色值
    onThemeColorCommit(e) {
      this.applyThemeColorInput(e.target);
    },
    // 校验并应用主题色值（仅处理插件自身弹出层 .c__input）
    applyThemeColorInput(target) {
      if (!target || !target.classList || !target.classList.contains('c__input')) return;
      let val = (target.value || '').trim();
      if (!val) return;
      // 兼容不带 # 的写法
      if (/^([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(val)) {
        val = '#' + val;
      }
      // 仅在合法 hex 时同步，避免插件内部 hex2rgb 产生 #aN 等异常值
      if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(val)) {
        this.form.ksh_theme_color = val;
        this.formErr.ksh_theme_color = '';
      }
    }
  }
};
</script>
<style scoped>
form >>> .ant-form-item-label > label{
  display: block;word-break: break-word; white-space: normal;
}
</style>
